import { useQueryClient } from '@tanstack/react-query';
import { http } from 'services/http';
import { ADDITIONAL_COSTS_GET_MANY } from 'api/query-keys';
import type { TCreateTripAdditionalCostReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useAddTripAdditionalCost = () => {
  const queryClient = useQueryClient();

  return useMutationBase<unknown, unknown, TCreateTripAdditionalCostReq>({
    mutationFn: async (variables) => {
      const res = await http.post<TCreateTripAdditionalCostReq>('/v1/additional-costs/trip', variables);
      return res.data;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: [ADDITIONAL_COSTS_GET_MANY, String(variables.tripId)] });
    },
  });
};
